import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Button, Colors, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { EditWorkspaceMenu } from './editWorkspaceMenu';

type Props = {
  workspaceIds: string[];
};

export const WorkspacesSelectionPanelMain = ({ workspaceIds }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Edit and Duplicate target a single workspace, so only surface
  // the actions with exactly one selection.
  const workspaceId = workspaceIds.length === 1 ? workspaceIds[0] : undefined;

  return (
    <View style={styles.container}>
      {workspaceId && (
        <>
          <EditWorkspaceMenu
            workspaceId={workspaceId}
            label={t('workspace.menu.editWorkspace')}
          />
          <Button
            variant="rounded"
            size="default"
            state="default"
            leftIcon={
              <MaterialCommunityIcons
                name="content-copy"
                color={Colors.blackText}
                size={16}
              />
            }
            onPress={() => navigate(`/workspaces/${workspaceId}/duplicate`)}
          >
            {t('workspace.menu.duplicateWorkspace', {
              defaultValue: 'Duplicate Workspace',
            })}
          </Button>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: tokens.spacing.lg,
    gap: tokens.spacing.md,
  },
});
